import React, { useEffect } from "react"
import Form from "../components/Forms/Form"
import Header from "../components/Header"
import Sogehts from "../components/home/Sogehts"

const Home: React.FC = () => {
	useEffect(() => {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: "smooth",
		})
	}, [])
	return (
		<>
			<Header page="start" />
			<Sogehts />
			<Form />
		</>
	)
}
export default Home
